// extracted by mini-css-extract-plugin
export default {"vertical":"DelegationsPromote_vertical__OrHPl","main":"DelegationsPromote_main__0zhtH","horizontal":"DelegationsPromote_horizontal__HrfiB","title":"DelegationsPromote_title__-dCiM"};